import { Component, OnInit } from '@angular/core';
import { SideService } from '../side.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(public side: SideService) { }

  ngOnInit() {}

  redirect(url) {
   window.open('https://' + url + '.alzis.es', '_blank' );
  }

}
